export default __webpack_public_path__ + "static/media/Head_3_Ear_1_C5.7a3390e1.svg";